<template>
  <div>
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="xl"
      title="Filtros para exportação"
    >
      <!-- {{ isExporting }} -->
      <b-row class="mb-3 ml-0">
        <checklist-filled-export-pdf
          class="ml-2"
          ref="exportPdf"
          :fields="fields"
          :table-filters="tableFilters"
          :allId.sync="allId"
          :exportType.sync="exportType"
          @refresh="refresh"
        ></checklist-filled-export-pdf>
      </b-row>
      <b-row class="mb-3 ml-0">
        <h4 class="ml-2">Exportações finalizadas</h4>
        <b-table
          ref="finishedExport"
          class="table-nowrap"
          :busy.sync="isBusy"
          :items="exportFinished"
          :fields="finishedExportFields"
          :filter="finishedExportFilter"
          :filter-debounce="500"
          :per-page="tablePerPage"
          :current-page="tableCurrentPage"
        >
          <template v-slot:cell(download)="data">
            <!-- {{ data.item }} -->
            <a
              href="#"
              v-if="data.item.status != 'Error'"
              @click="downloadFile(data.item.id)"
              ><b-button size="sm"
                ><b-icon icon="download" aria-hidden="true"></b-icon
              ></b-button>
            </a>

            <!-- download -->
          </template>
        </b-table>
        <table-pagination-props
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :perPage.sync="tablePerPage"
          :rowCount.sync="tableRowCount"
        >
        </table-pagination-props>
      </b-row>
      <b-row class="mb-3 ml-0">
        <h4>Em exportação</h4>
        <b-table
          ref="exportFile"
          class="table-nowrap"
          :items="startExportFile"
          :fields="exportFields"
          :per-page="tableStartPerPage"
          :current-page="tableStartCurrentPage"
          :filter="startExportFilter"
          :filter-debounce="500"
        >
        </b-table>
        <!-- <table-pagination-props
          :currentPage.sync="tableStartCurrentPage"
          :pageOptions.sync="tableStartPageOptions"
          :perPage.sync="tableStartPerPage"
          :rowCount.sync="tableStartRowCount"
        >
        </table-pagination-props> -->
      </b-row>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button class="ml-2" variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-button size="sm" @click="modalOpen">Exportar PDF</b-button>
  </div>
</template>
<script>
export default {
  name: "ChecklistExportPdfProgressModal",
  props: {
    fields: Array,
    tableFilters: Object,
    paginationPerPage: Number,
  },
  components: {
    ChecklistFilledExportPdf: () =>
      import("@/pagesRms/checklist/checklist/ChecklistFilledExportPdf.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  },
  data() {
    return {
      isBusy: false,
      finishedExport: [],
      finishedExportFields: [
        {
          key: "id",
          filterKey: "id",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "dateEndExport",
          filterKey: "dateEndExport",
          sortable: false,
          label: "Data",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "comulative",
          filterKey: "comulative",
          sortable: false,
          label: "Acumulativo",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "status",
          filterKey: "status",
          sortable: false,
          label: "Status",
          formatter: (value, key, item) => {
            if (item.status == "Finished") return "Finalizado";
            // else if (item.status == "Started") return "Iniciado";
            else if (item.status == "Error") return "Erro";
          },
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "download",
          filterKey: "download",
          sortable: false,
          label: "Download",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "message",
          filterKey: "message",
          sortable: false,
          label: "Mensagem de erro",
          tdClass: "table-col-dinamic-width",
        },
      ],
      exportFields: [
        {
          key: "id",
          filterKey: "id",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "dateStartExport",
          filterKey: "dateStartExport",
          sortable: false,
          label: "Data",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "progress",
          filterKey: "progress",
          sortable: false,
          label: "Progresso",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "comulative",
          filterKey: "comulative",
          sortable: false,
          label: "Acumulativo",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "status",
          filterKey: "status",
          sortable: false,
          label: "Status",
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            if (item.status == "Started") return "Iniciado";
          },
        },
      ],
      finishedExportFilter: [],
      startExportFilter: [],
      pdfAtual: null,
      allId: [],
      exportType: 0,
      // endExport: true,
      isExporting: false,
      timeRefresh: 86400,
      //paginação finalizado
      tableRowCount: 0,
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      //paginação iniciado
      tableStartRowCount: 0,
      tableStartPerPage: 10,
      tableStartPageOptions: [5, 10, 25, 50, 100, 150],
      tableStartCurrentPage: 1,
      tableStartSelectMode: "single",
      tableStartSelectedItem: [],
    };
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    refreshTable() {
      this.$refs.exportFile.refresh();
      // this.$refs.finishedExport.refresh();
    },
    refresh() {
      this.$refs.exportFile.refresh();

      this.timeRefresh = 10000;
      this.timer = setInterval(this.refreshTable, this.timeRefresh);
      this.$refs.exportPdf.hideModal();
    },
    exportFinished(ctx, callback) {
      this.isBusy = true;
      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
      };
      this.$apiChecklist
        .post("/checklist/getFinishedExport/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    startExportFile(ctx, callback) {
      this.isBusy = true;
      let filter = {
        currentPage: 1,
        perPage: 10,
      };

      this.$apiChecklist
        .post("/checklist/getStartExport/", filter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableStartRowCount = response.data.totalItems;
          if (items.length != 0) this.isExporting = true;
          else this.isExporting = false;
          this.pdfAtual = items[0];
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableStartRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    export() {
      this.isExporting = true;
      this.$apiChecklist
        .post("/checklist/exporToPdf/" + this.exportType, this.allId)
        .then((response) => {
          // this.endExport = false;
          this.getPdfAtual();
          this.isExporting = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
    downloadFile(exportId) {
      this.$apiChecklist
        .request({
          url: "/checklist/getExport/" + exportId,
          method: "POST",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
          // this.$refs.openModal.hide("modal-prevent-closing");
        });
    },
    getPdfAtual() {
      this.$apiChecklist
        .get("/checklist/getLastExport/")
        .then((response) => {
          this.pdfAtual = response.data;
          this.downloadFile(this.pdfAtual.id);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
  watch: {
    allId() {
      this.export();
    },
    isExporting() {
      this.refresh();
    },
  },
};
</script>
